import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import Modal from 'utils/packages/Modal';
import SectionHeader from 'design-system/SectionHeader';
import LogoBankAccount from 'design-system/LogoBankAccount';
import TransferAccountRow from 'features/transfers/components/TransferAccountRow';
import { selectConnectedBankAccount } from 'features/wealth/selectors';
import { useAppSelector } from 'store/hooks';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import Amount from 'design-system/Amount';
import { useConnectedAccount } from '../hooks/selectors';
import { selectTradingAccountFromId } from '../reducers/selectors';
const strings = {
    title: 'Choose a deposit method',
    fastTransfers: 'Fast transfers',
    otherTransferType: 'Other transfer type',
    openBankingTransfer: 'Open Banking transfer',
    directDebit: 'Direct Debit',
    openBankingTiming: 'Usually instant',
    directDebitTiming: 'May take up to 5 working days',
    continue: 'Continue',
};
const getAccountLabel = (bankAccount) => `${bankAccount.name || 'Linked bank'} • ${!bankAccount.accountNumber ? '****' : bankAccount.accountNumber.slice(-4)}`;
const TradingAccountDepositMethodPickerModalContent = ({ current, onSelect, showCash, tradingAccountId, }) => {
    const connectedAccount = useConnectedAccount();
    const connectedBankAccount = useAppSelector(selectConnectedBankAccount);
    const tradingAccount = useAppSelector((state) => selectTradingAccountFromId(state, tradingAccountId));
    const accountLabel = connectedBankAccount ? getAccountLabel(connectedBankAccount) : undefined;
    const handleConfirm = useCallback((depositMethod) => () => {
        onSelect(depositMethod);
        TradingAccountDepositMethodPickerModal.hide();
    }, [onSelect]);
    return (<>
      <Spacer h={24}/>
      <SectionHeader horizontalMargins>{strings.fastTransfers}</SectionHeader>
      <Spacer h={8}/>
      {connectedAccount?.pispBankId ? (<TransferAccountRow name={strings.openBankingTransfer} selected={current === 'openBankingDeposit'} onPress={handleConfirm('openBankingDeposit')} Icon={connectedAccount ? <LogoBankAccount size="R44" data={connectedAccount}/> : null} desc={<>
              {!!accountLabel && (<Text TextThin-14 Secondary>
                  {accountLabel}
                </Text>)}
              <Text TextThin-14 Secondary>
                {strings.openBankingTiming}
              </Text>
            </>}/>) : null}
      {!!showCash && (<TransferAccountRow name="Cash" Icon={<IconEmmaWallet />} selected={current === undefined} onPress={handleConfirm(undefined)} desc={tradingAccountId && tradingAccount?.availableToInvest ? (<View style={styles.row}>
                <Text TextThin-14 Secondary>
                  Available{' '}
                </Text>
                <Amount NumbersThin-14 Secondary value={tradingAccount.availableToInvest}/>
              </View>) : undefined}/>)}
      <Spacer h={16}/>
      <SectionHeader horizontalMargins>{strings.otherTransferType}</SectionHeader>
      <Spacer h={8}/>
      <TransferAccountRow name={strings.directDebit} selected={current === 'singleDirectDebit'} onPress={handleConfirm('singleDirectDebit')} Icon={connectedAccount ? <LogoBankAccount size="R44" data={connectedAccount}/> : null} desc={<>
            {!!accountLabel && (<Text TextThin-14 Secondary>
                {accountLabel}
              </Text>)}
            <Text TextThin-14 Secondary>
              {strings.directDebitTiming}
            </Text>
          </>}/>
    </>);
};
export const TradingAccountDepositMethodPickerModal = {
    show: (onSelect, current, onDidHideCallback, tradingAccountId, showCash) => {
        Modal.show(<TradingAccountDepositMethodPickerModalContent onSelect={onSelect} current={current} showCash={showCash} tradingAccountId={tradingAccountId}/>, {
            onDidHideCallback,
            title: strings.title,
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
});
